import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Spinner, Container, Card } from 'react-bootstrap';
import { verifyEmailAPI } from '../../services/authService';
import { LOGIN_ROUTE } from '../../routes/RoutesPathes';
import { useTranslation } from 'react-i18next';
import { StatusCircle } from '../../components/general/StatusCircle';

export const EmailVerification = () => {
  const { uid, token } = useParams();
  const { t, i18n } = useTranslation();
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
  const [message, setMessage] = useState('');
  const arrow = i18n.dir() === 'rtl' ? '←' : '→';

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await verifyEmailAPI(uid, token);
        if (response.status === 200) {
          setStatus('success');
          setMessage(t("pages.email_verification.success_body"));
        } else {
          setStatus('error');
          setMessage(t("pages.email_verification.fail_body"));
        }
      } catch (err) {
        setStatus('error');
        setMessage(t("titles.something_went_wrong"));
        if (err.response?.status === 400) {
          setMessage(t("pages.email_verification.fail_body"));
        }
      }
    };

    verifyEmail();
  }, [uid, token, t]);

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '70vh' }}>
      <Card style={{ width: '100%', maxWidth: '500px' }} className="text-center shadow p-4">
        {status === 'loading' && (
          <>
            <Spinner animation="border" role="status" className="mb-3 mx-auto" />
            <h5>{t("pages.email_verification.loading_title")}</h5>
          </>
        )}

        {status === 'success' && (
          <>
            <div className='d-flex flex-column justify-content-center align-items-center'>
              <StatusCircle status='success'/>
              <h4 className="mt-3">{t("pages.email_verification.success_title")}</h4>
            </div>
            <p>{message}</p>
            <span>
              <Link to={LOGIN_ROUTE} className="s-link s-purple-link">{t("buttons.login")} {arrow}</Link>
            </span>
          </>
        )}

        {status === 'error' && (
          <>
            <div className='d-flex flex-column justify-content-center align-items-center'>
              <StatusCircle status={'failure'}/>
              <h4 className="mt-3">{t("pages.email_verification.fail_title")}</h4>
            </div>
            <p>{message}</p>
          </>
        )}
      </Card>
    </Container>
  );
};
